import {
  useAxios,
  useHandleApiError,
} from '@sttedra_ui/framework';

// #region Globals
const {base} = useAxios();
const {handleApiError} = useHandleApiError();
const CONTEXT_BASE_PATH = 'Users';
// #endregion

// #region Public functions
/**
 * Realiza la comprobación de si el token ha caducado.
 *
 * @param {string} token Token a comprobar.
 * @returns {Promise} Promesa con el resultado de la comprobación.
 */
async function checkTokenLapsed(token) {
  try {
    const response = await base.post(`/${CONTEXT_BASE_PATH}/validateToken`, token, {
      headers: {'Content-Type': 'application/json'},
    });
    return response;
  } catch (err) {
    return handleApiError(err, {silent: true});
  }
}
// #endregion

export {checkTokenLapsed};
